<template>
  <div class="relative bg-gray-800 rounded-xl border border-gray-500 py-2 px-2">
    <div
      class="flex flex-wrap justify-between items-center gap-4 xl:gap-6 2xl:gap-8"
    >
      <div class="text-sm flex items-center gap-2">
        <div class="font-bold">{{ this.wallet.name }}:</div>
        <a
          target="_blank"
          :href="this.explorerUrlAddress(this.wallet.address)"
          class="text-sm hover:underline hover:text-blue-500"
        >
          {{ this.shortAddress(this.wallet.address) }}
        </a>
        <copy :value="this.wallet.address" />
        <copy :value="this.wallet.privateKey">
          <template #icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-5 text-gray-500"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
              />
            </svg>
          </template>
        </copy>
      </div>
      <div class="flex justify-between items-center">
        <div class="text-sm gap-1 flex items-center">
          <div class="font-bold text-red-400">
            {{ balanceFormat(this.balanceNative(this.wallet.address)) }}
          </div>
          <div>{{ this.wrappedToken }}</div>
        </div>
      </div>
      <div
        class="bg-gray-800 shadow shadow-red-700 hover:shadow-red-600 px-4 py-1 text-sm font-bold rounded-xl cursor-pointer text-gray-300"
        @click="this.confirm(this.wallet)"
      >
        Remove
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Copy from "@/components/Copy.vue";

export default {
  name: "RemoveWallet",
  components: { Copy },
  props: {
    wallet: {
      type: Object,
      required: true,
    },
    confirm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters("app", ["balanceFormat"]),
    ...mapGetters("network", [
      "shortAddress",
      "wrappedToken",
      "explorerUrlAddress",
    ]),
    ...mapGetters("wallet", ["balanceNative"]),
  },
  methods: {},
};
</script>
